export class QuestionnaireListItem {
  constructor(
    public id: string,
    public title: string,
    public description: string,
    public time: string,
    public view_only: boolean
  ) {}
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/questionnaire-list-item.ts